module.exports = __webpack_public_path__ + "static/media/m3.107a6246.svg";